import { Data as Data$1, Underwriting as Underwriting$1, Details as Details$1 } from './contract/contract-surety-quote.types.mjs';
import * as contractSuretyQuote_types from './contract/contract-surety-quote.types.mjs';
export { contractSuretyQuote_types as Contract };

var Data;
(function (Data) {
    Data.schema = Data$1.schema;
})(Data || (Data = {}));
var Underwriting;
(function (Underwriting) {
    Underwriting.schema = Underwriting$1.schema;
})(Underwriting || (Underwriting = {}));
var Details;
(function (Details) {
    Details.schema = Details$1.schema;
})(Details || (Details = {}));

export { Data, Details, Underwriting };
